import getDateIntervall from './getDateIntervall'
import sortPerformancesByDate from './sortPerformancesByDate'
import getDateObject from './getDateObj'

const getPerformancesIntervall = (performances, currentPeriodeStartDate, currentPeriodeEndDate) => {
    let dayIntervall

    const performancesSortedByDate = sortPerformancesByDate(performances)
    const firstCurrentPerformance = _.find(performancesSortedByDate, performance => {
        return currentPeriodeStartDate <= getDateObject(performance.timeUtc) && currentPeriodeEndDate >= getDateObject(performance.timeUtc)
    })

    let firstcurrentPerformanceDate 

    if(!firstCurrentPerformance) {
        return ''
    }

    firstcurrentPerformanceDate = getDateObject(firstCurrentPerformance.timeUtc)

    if(firstcurrentPerformanceDate <= currentPeriodeEndDate) {
        dayIntervall = getDateIntervall(currentPeriodeStartDate, currentPeriodeEndDate)        
    } else {
        dayIntervall = getDateIntervall(firstcurrentPerformanceDate, getDateObject(performancesSortedByDate[performancesSortedByDate.length - 1].timeUtc))
    }

    performances.map(performance => {
        const performanceDate = getDateObject(performance.timeUtc)
        const key = performanceDate.toISOString()

        if(_.has(dayIntervall, key)) {
            dayIntervall[key].push(performance)
        }
    })

    return dayIntervall
}

export default getPerformancesIntervall